import ui from './ui'
import auth from './authetication'
import newProduct from './newProduct'

export default {
  ...ui,
  ...auth,
  ...newProduct
}
